import React from 'react';


/**
 *
 */
class Footer extends React.PureComponent {

    render = () => {

        return (
            <div className='Footer'>
                <div className='Container'>
                    <div className='Footer__companies'>
                        <div className='Footer__title'>Zakládající firmy:</div>
                        <div className='Footer__companiesList'>
                            <a href='https://google.com' target='_blank' rel="noopener noreferrer"
                               className='Footer__company'>VirtualTraining</a>
                            <a href='https://google.com' target='_blank' rel="noopener noreferrer"
                               className='Footer__company'>Sportsoft timing</a>
                            <a href='https://google.com' target='_blank' rel="noopener noreferrer"
                               className='Footer__company'>Styrax</a>
                            <a href='https://google.com' target='_blank' rel="noopener noreferrer"
                               className='Footer__company'>Rohde & Schwarz</a>
                            <a href='https://google.com' target='_blank' rel="noopener noreferrer"
                               className='Footer__company'>R/S</a>
                        </div>
                    </div>
                    <div className='Footer__about'>
                        <div className='Footer__column'>
                            <address>
                                VIM.Perk, z.s.,<br/>
                                Špidrova 90,<br/>
                                385 01 Vimperk
                            </address>
                        </div>
                        <div className='Footer__column'>
                            IČO: 08453926<br/>
                            Bankovní spojení:<br/>
                            2201695274/2010
                        </div>
                        <div className='Footer__column'>
                            <a href='mailto:jitka.schneiderova'>jitka.schneiderova</a><br/>
                            <a href='https://twitter.com'>@vimdotperk.cz</a><br/>
                            <a href='tel:+420777096369'>777 096 369</a>
                        </div>
                        <div className='Footer__column'>
                            <a href='https://facebook.com/' target='_blank' rel="noopener noreferrer">Facebook</a><br/>
                            <a href='https://youtube.com' target='_blank' rel="noopener noreferrer">Youtube</a><br/>
                            <a href='https://instagram.com' target='_blank' rel="noopener noreferrer">Instagram</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

}


export default Footer;